export default __webpack_public_path__ + "static/media/790246074178469908.15c916aa.png";